import React, { memo, useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Alert, Typography } from 'antd';
import { useFieldController } from '../../../../../../helpers/formManager';
import { fieldNames } from '../../constants';
import { RoomsTable } from '../../../../controllers/RoomsTable';
import { useRoomListForIndividualDates } from '../../../../services/queries/roomsForIndividualDates';
import styles from './index.module.scss';

const MemoizedRoomList = memo(RoomList);

const SelectRooms = () => {
  const { data, isFetching, refetch } = useRoomListForIndividualDates();

  const {
    field: { value, onChange },
    fieldState,
  } = useFieldController({
    name: fieldNames.addresses,
    rules: { required: 'Выберите помещения' },
    defaultValue: [],
  });

  const relatedMap = useMemo(() => {
    return createRelatedMap(data);
  }, [data]);

  return (
    <div className={styles.root}>
      <HasSelectedRelatedRooms value={value} relatedMap={relatedMap}>
        {Boolean(fieldState.error) && (
          <Typography.Text type="danger">
            {fieldState.error.message}
          </Typography.Text>
        )}
        <MemoizedRoomList
          value={value}
          onChange={onChange}
          data={data}
          isFetching={isFetching}
          refetch={refetch}
          relatedMap={relatedMap}
        />
      </HasSelectedRelatedRooms>
    </div>
  );
};

export default SelectRooms;

function HasSelectedRelatedRooms({ children, value, relatedMap }) {
  const [hasRelated, setHasRelated] = useState(false);

  useEffect(() => {
    const next =
      value?.length && relatedMap.size
        ? value.some((id) => relatedMap.has(id))
        : false;
    setHasRelated(next);
  }, [value, relatedMap]);

  return (
    <>
      {hasRelated && (
        <Alert
          message="Обратите внимание"
          description="Среди выбранных помещений присутствуют связанные помещения"
          type="warning"
        />
      )}
      {children}
    </>
  );
}

const accesses = { [RoomsTable.accessesKeys.canChangeLifeCycle]: false };
function RoomList({ onChange, value, data, isFetching, refetch, relatedMap }) {
  const history = useHistory();

  const handleChange = ({ value, valueSet, targetKeysSet, selected }) => {
    let hasChanges = false;

    const action = selected ? 'add' : 'delete';

    targetKeysSet.forEach((key) => {
      const related = relatedMap.get(key);

      if (related) {
        hasChanges = true;
        related.forEach((id) => {
          valueSet[action](id);
        });
      }
    });

    onChange(hasChanges ? Array.from(valueSet) : value);
  };

  return (
    <RoomsTable
      withCheckbox
      data={data}
      isFetching={isFetching}
      refetch={refetch}
      preset={RoomsTable.presets.addIndividualDates}
      rowSelectionConfig={{ value, onChange: handleChange }}
      acceptance={history.location.state?.from?.acceptance}
      accesses={accesses}
    />
  );
}

const emptyMap = new Map();
function createRelatedMap(items) {
  if (!Array.isArray(items)) return emptyMap;

  const map = new Map();

  items.forEach((item) => {
    if (item.relatedFlats?.length) {
      map.set(item.id, new Set(item.relatedFlats.map((flat) => flat.id)));
    }
  });

  return map;
}
